/**
 * <ThemeSetting 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Form from 'components/Form';
import locale from '../locale';
import './ThemeSetting.scss';

class ThemeSetting extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      site: {},
    }

    this.getValidationRef = this.getValidationRef.bind(this);
  }

  onChange(themeSetting) {
    this.setState({
      site: {
        ...this.state.site,
        themeSetting,
      }
    });
  }

  componentWillMount() {

  }

  componentWillReceiveProps(props) {
    if (props.site) {
      this.setState({
        site: props.site,
      });
    }
  }

  getValidationRef(validateFn) {
    this.validateFn = validateFn;

  }

  onSubmit() {
    this.props.onSubmitThemeSetting(this.state.site); 
  }

  onChange(themeSetting) {
    this.setState({
      site: {
        ...this.state.site,
        themeSetting,
      }
    });
  }

  render() {
    const {
      settingSchema,
      onCloseThemeSetting,
      onSubmitThemeSetting,
    } = this.props;

    const {
      site,
    } = this.state;

    return (
      <div className='ThemeSetting'>
        <div className={classnames('ThemeSetting--content')} ref={(r)=>{ this.scrollingContainerRef = r; }}>
          { settingSchema.map((schema, index)=>{
              return (<Form
                key={index}
                onChange={this.onChange}
                schema={schema.fields}
                formData={site.themeSetting}
                formStyle='outline'
                getValidationRef={this.getValidationRef}
                scrollingContainerRef={this.scrollingContainerRef}
              />);
          })}
        </div>
        <div className='btn-wrapper'>
          <button onClick={onCloseThemeSetting} className='btn btn-default'>{__('Cancel', locale)}</button>
          <button onClick={this.onSubmit} className='btn btn-primary'>{__('Submit', locale)}</button>
        </div>
      </div>
    )
  }
}

export default ThemeSetting;



// WEBPACK FOOTER //
// ./src/containers/pages/Website/ThemeSetting/index.js